define(["exports", "./utils", "./expose-modules", "hyperhtml", "./pubsubhub"], function (_exports, _utils, _exposeModules, _hyperhtml, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.rsDocToDataURL = rsDocToDataURL;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n    <meta name=\"generator\" content=\"", "\">\n  "]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["<meta charset=\"utf-8\">"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const mimeTypes = new Map([["text/html", "html"], ["application/xml", "xml"]]);
  /**
   * Creates a dataURI from a ReSpec document. It also cleans up the document
   * removing various things.
   *
   * @param {String} mimeType mimetype. one of `mimeTypes` above
   * @param {Document} doc document to export. useful for testing purposes
   * @returns a stringified data-uri of document that can be saved.
   */

  function rsDocToDataURL(mimeType, doc = document) {
    const format = mimeTypes.get(mimeType);

    if (!format) {
      const validTypes = [...mimeTypes.values()].join(", ");
      const msg = "Invalid format: ".concat(mimeType, ". Expected one of: ").concat(validTypes, ".");
      throw new TypeError(msg);
    }

    const data = serialize(format, doc);
    const encodedString = encodeURIComponent(data);
    return "data:".concat(mimeType, ";charset=utf-8,").concat(encodedString);
  }

  function serialize(format, doc) {
    const cloneDoc = doc.cloneNode(true);
    cleanup(cloneDoc);
    let result = "";

    switch (format) {
      case "xml":
        result = new XMLSerializer().serializeToString(cloneDoc);
        break;

      default:
        {
          if (cloneDoc.doctype) {
            result += new XMLSerializer().serializeToString(cloneDoc.doctype);
          }

          result += cloneDoc.documentElement.outerHTML;
        }
    }

    return result;
  }

  function cleanup(cloneDoc) {
    const {
      head,
      body,
      documentElement
    } = cloneDoc;
    (0, _utils.removeCommentNodes)(cloneDoc);
    cloneDoc.querySelectorAll(".removeOnSave, #toc-nav").forEach(elem => elem.remove());
    body.classList.remove("toc-sidebar");
    (0, _utils.removeReSpec)(documentElement);
    const insertions = cloneDoc.createDocumentFragment(); // Move meta viewport, as it controls the rendering on mobile.

    const metaViewport = cloneDoc.querySelector("meta[name='viewport']");

    if (metaViewport && head.firstChild !== metaViewport) {
      insertions.appendChild(metaViewport);
    } // Move charset to near top, as it needs to be in the first 512 bytes.


    let metaCharset = cloneDoc.querySelector("meta[charset], meta[content*='charset=']");

    if (!metaCharset) {
      metaCharset = (0, _hyperhtml.default)(_templateObject());
    }

    insertions.appendChild(metaCharset); // Add meta generator

    const respecVersion = "ReSpec ".concat(window.respecVersion || "Developer Channel");
    const metaGenerator = (0, _hyperhtml.default)(_templateObject2(), respecVersion);
    insertions.appendChild(metaGenerator);
    head.prepend(insertions);
    (0, _pubsubhub.pub)("beforesave", documentElement);
  }

  (0, _exposeModules.expose)("core/exporter", {
    rsDocToDataURL
  });
});
//# sourceMappingURL=exporter.js.map